import { render, staticRenderFns } from "./LatestPage.vue?vue&type=template&id=23e376f2&"
import script from "./LatestPage.vue?vue&type=script&lang=js&"
export * from "./LatestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports